<rfx-grid-filter-control>
	<button
		mat-button
		type="button"
		(click)="clearFilters()"
	>
		Clear Filters
	</button>
</rfx-grid-filter-control>